export function drawCanvas({
  canvas,
  image,
  scale,
  offset,
  grid,
}) {
  if (!canvas || !image) return;

  const ctx = canvas.getContext("2d");

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    image,
    offset.x,
    offset.y,
    image.width * scale,
    image.height * scale
  );

  const cellW = canvas.width / grid.cols;
  const cellH = canvas.height / grid.rows;

ctx.strokeStyle = "rgba(17, 17, 17, 0.45)";
ctx.lineWidth = 2;

  for (let i = 0; i <= grid.cols; i++) {
    ctx.beginPath();
    ctx.moveTo(i * cellW, 0);
    ctx.lineTo(i * cellW, canvas.height);
    ctx.stroke();
  }

  for (let j = 0; j <= grid.rows; j++) {
    ctx.beginPath();
    ctx.moveTo(0, j * cellH);
    ctx.lineTo(canvas.width, j * cellH);
    ctx.stroke();
  }
}